var cleanPhoneNumber = function cleanPhoneNumber(phoneNumber) {
  if (!phoneNumber) {
    return phoneNumber;
  }
  var trimmedTel = phoneNumber.trim();
  return trimmedTel.replace(/[^\d+]/g, '');
};
var formatPhone = function formatPhone(phone) {
  if (!phone) {
    return phone;
  }
  return phone.indexOf('+') === 0 ? phone.replace('+', '00') : phone;
};

export { cleanPhoneNumber, formatPhone };
